import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { serverDomain } from "../config";
import "./SideBar.css";

const SideBar = () => {
  const location = useLocation();
  const [userRole, setUserRole] = useState(null);
  const [isSwitched, setIsSwitched] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const adminToken = localStorage.getItem("adminToken");

    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split(".")[1]));
        setUserRole(decodedToken.role);
      } catch (error) {
        console.error("Ошибка декодирования токена:", error);
      }
    }

    if (adminToken) setIsSwitched(true);
  }, []);

  const handleSwitchBack = async () => {
    try {
      const adminToken = localStorage.getItem("adminToken");
      if (!adminToken) return alert("Ошибка: не найден админский токен.");

      const response = await axios.post(
        `${serverDomain}/api/admin/switch-back`,
        { adminToken },
        { headers: { Authorization: `Bearer ${adminToken}` } }
      );

      localStorage.setItem("token", response.data.token);
      localStorage.removeItem("adminToken");
      setIsSwitched(false);
      window.location.reload();
    } catch (error) {
      console.error("Ошибка возврата в аккаунт администратора", error);
    }
  };

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/")
      ? "active"
      : "";

  const items = [
    { to: "/statistics", label: "Статистика", icon: "/icons/statistics.png" },
    { to: "/offers", label: "Офферы", icon: "/icons/offers.png" },
    { to: "/streams", label: "Потоки", icon: "/icons/streams.png" },
    { to: "/payments", label: "Выплаты", icon: "/icons/payments.png" },
    { to: "/referrals", label: "Рефералы", icon: "/icons/referrals.png" },
    { to: "/logs", label: "Логи Postback", icon: "/icons/postbacklogs.png" },
    { to: "/help", label: "Помощь", icon: "/icons/help.png" },
    { to: "/support", label: "Поддержка", icon: "/icons/help.png" },
  ];

  return (
    <aside className="side-bar fl-menu">
      <div className="fl-menu__inner">
        <div className="sidebar-menu fl-menu__grid">
          {items.map((it) => (
            <Link key={it.to} to={it.to} className={`fl-menu__item ${isActive(it.to)}`}>
              <img src={it.icon} alt={it.label} className="sidebar-icon fl-menu__icon" />
              <div className="fl-menu__label">{it.label}</div>
            </Link>
          ))}

          {userRole === "admin" && (
            <Link to="/admin" className={`fl-menu__item ${isActive("/admin")}`}>
              <div className="fl-menu__label">Админ</div>
            </Link>
          )}
        </div>

        {isSwitched && (
          <button className="fl-menu__switchback" onClick={handleSwitchBack}>
            Вернуться в аккаунт администратора
          </button>
        )}
      </div>
    </aside>
  );
};

export default SideBar;
